/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_AupInputs */

const en_landing_footer_aup = /** @type {(inputs: Landing_Footer_AupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptable Use Policy`)
};

const zh_landing_footer_aup = /** @type {(inputs: Landing_Footer_AupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可接受使用政策`)
};

/**
* | output |
* | --- |
* | "Acceptable Use Policy" |
*
* @param {Landing_Footer_AupInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_footer_aup = /** @type {((inputs?: Landing_Footer_AupInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_AupInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_footer_aup(inputs)
	return zh_landing_footer_aup(inputs)
});
export { landing_footer_aup as "landing.footer.aup" }